import { ApolloClient, ErrorPolicy, FetchPolicy, InMemoryCache, NormalizedCacheObject } from '@apollo/client'
import { API_CHECKOUT_ORIGIN, CONFIG_SHOPIFY_STOREFRONT_ACCESS_TOKEN } from '@src/config/env'

const clientOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache' as FetchPolicy,
    errorPolicy: 'ignore' as ErrorPolicy,
  },
  query: {
    fetchPolicy: 'no-cache' as FetchPolicy,
    errorPolicy: 'all' as ErrorPolicy,
  },
}

let shopifyClient: ApolloClient<NormalizedCacheObject> | undefined

export class ShopifyClientBuilder {
  static getShopifyClient() {
    if (!shopifyClient) {
      try {
        shopifyClient = new ApolloClient({
          uri: `${API_CHECKOUT_ORIGIN}/api/2022-10/graphql.json`,
          cache: new InMemoryCache(),
          headers: {
            'X-Shopify-Storefront-Access-Token': CONFIG_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
          },
          defaultOptions: clientOptions,
        })
      } catch (error) {
        console.error(error)
      }
    }
    return shopifyClient || {}
  }
}
